import { render } from "./ResizableColumns.vue?vue&type=template&id=1bf068d7"
import script from "./ResizableColumns.vue?vue&type=script&lang=js"
export * from "./ResizableColumns.vue?vue&type=script&lang=js"

import "./ResizableColumns.vue?vue&type=style&index=0&id=1bf068d7&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__